import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { useCallback, useEffect, useState } from 'react';
import TailwindMultiSelect from 'widgets/editors/tailwind-multiselect';
import { InstructorExpertiseDto, InstructorExpertiseStore } from 'stores/skills/instructor-expertise-store';
import { UserDto } from 'stores/users/users-store';

interface TailwindMultipleInstructorEditorProps {
  value: UserDto[];
  clearable?: boolean;
  onChange?: (value: InstructorExpertiseDto[]) => void;
  instructorExpertisesStore?: InstructorExpertiseStore;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
}

const TailwindMultipleInstructorEditor: React.FC<TailwindMultipleInstructorEditorProps> = ({
  value,
  clearable = true,
  onChange,
  instructorExpertisesStore,
  placeholder,
  className,
  disabled = false,
  onBlur,
  onFocus
}) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<InstructorExpertiseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const getInstructorExpertisesMethod = useCallback(async () => {
    try {
      setIsLoading(true);
      const instructorExpertises = await instructorExpertisesStore.getAllWithGhostsAsync(
        {
          searchQuery: ``,
          orderBy: [],
          filter: [],
          skip: 0,
          take: 100000
        },
        true
      );

      setOptions(instructorExpertises.items || []);
    } catch (error) {
      console.error('Error loading locations:', error);
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  }, [instructorExpertisesStore]);

  useEffect(() => {
    getInstructorExpertisesMethod();
  }, [getInstructorExpertisesMethod]);

  return (
    <TailwindMultiSelect
      options={
        isLoading
          ? [{ id: 'loading', text: t('Loading...'), disabled: true }]
          : options.length > 0
          ? options.map(expertise => ({
              id: expertise.id,
              text: expertise.instructor
            }))
          : [{ id: 'no-options', text: t('No options available'), disabled: true }]
      }
      value={
        Array.isArray(value)
          ? value.map(v => ({
              id: v.id,
              text: v.firstName
            }))
          : []
      }
      onChange={newValue => {
        const selectedIntructorExpertises = newValue.map(v => options.find(opt => opt.id === v.id)).filter(Boolean);
        onChange(selectedIntructorExpertises);
      }}
      placeholder={placeholder || t('Select instructors')}
      clearable={clearable}
      disabled={disabled}
      className={className}
      onBlur={onBlur}
      onFocus={onFocus}
      searchable={!isLoading}
    />
  );
};

// Wire up the React component to the Redux store
export default connect(['instructorExpertisesStore', InstructorExpertiseStore])(TailwindMultipleInstructorEditor);
